class ReadMore {
    constructor() {
        this.containerList = document.querySelectorAll('[data-readmore]');
    }

    init() {
        if (this.containerList.length > 0 ) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.containerList.forEach(container => {
            const button = container.querySelector('.read-more-button');

            button.addEventListener('click', function(event) {
                container.classList.toggle('is-open');
            });
        });
    }
}

export default new ReadMore();
